import { render, staticRenderFns } from "./ModifyUser.vue?vue&type=template&id=2b65f6e6&"
import script from "./ModifyUser.vue?vue&type=script&lang=js&"
export * from "./ModifyUser.vue?vue&type=script&lang=js&"
import style0 from "./ModifyUser.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports